import React from 'react';

import Select from 'react-select';

import classStatus from '@/data/classStatus';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectClassSurveyStatus: React.FC<any> = ({ name, value, defaultValue, handleChange, placeholder, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={classStatus.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={classStatus}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectClassSurveyStatus;
